import { h, Component } from 'preact';
import Calendar from 'components/bolt/icons/calendar';
import Clock from 'components/bolt/icons/clock';
import Reel from 'components/bolt/icons/reel';
import { SmallTicket } from 'helpers/svgs';
import { getScreeningDetailsFormatted } from 'helpers/screeningDetails';
import { joinClasses } from 'utils/utils';
import { getShowtimesData } from 'utils/bolt/showtimes';
import s from 'components/bolt/ticket/ticket.sss';


export default class Ticket extends Component {

	renderTheaterHeading(ticket) {
		const sharedImageRoot = this.props?.appData?.urls?.roots?.sharedImages || '';
		const logoShade = 'light';
		const logo = ticket?.theater?.chain?.logo || 'default.png';
		const logoLink = `${sharedImageRoot}/logos/${logoShade}/${logo}`;
		return (
			<div class={s.theaterContainer}>
				<img class={s.theaterLogo} src={logoLink} alt="theater logo" />
				<span class={s.theaterName}>{ticket?.theater?.name}</span>
			</div>
		);
	}

	renderScreeningDetails(ticket, numTickets) {
		const movieName = this.props?.appData?.meta?.title?.locale || '';

		const formatted = getScreeningDetailsFormatted({
			date: ticket?.screening?.date || '',
			time: ticket?.screening?.time || '',
			format: ticket?.screening?.format
		}, getShowtimesData()?.clockFormat);

		return (
			<div class={s.screeningDetailsContainer}>
				<span class={s.movieName}>{movieName}</span>
				<div class={s.details}>
					<div class={s.detail}>
						<Calendar class={s.detailIcon} />
						<span class={s.detailText}>{formatted.date}</span>
					</div>
					<div class={s.detail}>
						<Clock class={s.detailIcon} />
						<span class={s.detailText}>{formatted.time}</span>
					</div>
					<div class={s.detail}>
						<Reel class={s.detailIcon} />
						<span class={s.detailText}>{formatted.format}</span>
					</div>
					<div class={s.detail}>
						<SmallTicket class={s.detailIcon} />
						<span class={joinClasses(s.detailText, s.quantity)}>{numTickets}</span>
					</div>
				</div>
			</div>
		);
	}

	renderNotchSection() {
		return (
			<div class={s.notchContainer} />
		);
	}

	render(props) {
		const { ticketData, appData, extraClass } = props;
		const numTickets = ticketData?.length;
		const ticket = ticketData?.[0] || {};

		return (
			<div class={joinClasses(s.container, extraClass)}>
				{this.renderTheaterHeading(ticket)}
				{this.renderScreeningDetails(ticket, numTickets)}
				<div class={s.nameContainer}>
					<span class={s.nameHeading}>{appData?.copy?.baseCopy?.$NAME}</span>
					<span class={s.name}>{ticket.userFullName}</span>
				</div>
				{this.renderNotchSection()}
				<div class={s.emailContainer}>
					<span class={s.emailHeading}>{appData?.copy?.baseCopy?.$EMAIL}</span>
					<span class={s.email}>{ticket.userEmail}</span>
				</div>
			</div>
		);
	}
}